import { Injectable } from '@angular/core';
import { OrderUserProfileFilter } from '@order/const';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class OnlineOrdersListComponentService {
  private orderUserProfileFilter$: BehaviorSubject<OrderUserProfileFilter> =
    new BehaviorSubject<OrderUserProfileFilter>(OrderUserProfileFilter.ALL);

  setOrderUserProfileFilter(orderUserProfileFilter: OrderUserProfileFilter): void {
    this.orderUserProfileFilter$.next(orderUserProfileFilter);
  }

  getOrderUserProfileFilter(): BehaviorSubject<OrderUserProfileFilter> {
    return this.orderUserProfileFilter$;
  }
}
